import React from "react";
import styled from "styled-components";

const IconPermalink = () => {
  return (
    <StyledIconPermalink xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.55 20.65">
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <rect x="6.11" y="8.83" width="8.33" height="3" rx=".8" ry=".8" transform="translate(-4.29 10.29) rotate(-45)" strokeWidth="0"/>
          <path d="m9.94,5.23l.99-.99c1.32-1.32,3.42-1.64,4.96-.6,2.07,1.4,2.26,4.25.59,5.92l-1.11,1.11c-.34.34-.34.88,0,1.22l.9.9c.34.34.88.34,1.22,0l.9-.9c2.48-2.48,2.94-6.49.77-9.25-2.58-3.29-7.38-3.5-10.24-.64l-1.11,1.11c-.34.34-.34.89,0,1.23l.9.9c.34.34.89.34,1.23,0Z" strokeWidth="0"/>
          <rect x="6.11" y="8.83" width="8.33" height="3" rx=".8" ry=".8" transform="translate(-4.29 10.29) rotate(-45)" strokeWidth="0"/>
          <path d="m10.61,15.43l-.99.99c-1.32,1.32-3.42,1.64-4.96.6-2.07-1.4-2.26-4.25-.59-5.92l1.11-1.11c.34-.34.34-.88,0-1.22l-.9-.9c-.34-.34-.88-.34-1.22,0l-.9.9c-2.48,2.48-2.94,6.49-.77,9.25,2.58,3.29,7.38,3.5,10.24.64l1.11-1.11c.34-.34.34-.89,0-1.23l-.9-.9c-.34-.34-.89-.34-1.23,0Z" strokeWidth="0"/>
        </g>
      </g>
    </StyledIconPermalink>
  )
};
export default IconPermalink;

const StyledIconPermalink = styled.svg`
  position: relative;
  display: block;
  height: 0.875em;
  path,
  rect {
    fill: currentColor;
  }
`;
